
import Augur from "../../../assets/duotone/Augur.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AugurIcon({ className, dataTestid = "AugurIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Augur data-testid={dataTestid} className={classes} {...rest} />
  );
}
